module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahip44-6fb496c616f6c149f16c4058c24b2186.jpg";